export enum SectionName {
    LastViewed,
    Appointments,
    Messages,
    OpenHouses
}